module.exports = __webpack_public_path__ + "media/src/assets/Images/LandingTickBlue-f8f97ee505a89a26b17e7e46ea6d4f8c.svg";